//  Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, Input } from '@angular/core';
import { PolicyCompliance } from '../../../../types/d3ePolicy';

@Component({
    selector: 'app-policy-compliance-status',
    templateUrl: './policy-compliance-status.component.html',
    styleUrl: './policy-compliance-status.component.scss',
    standalone: false
})
export class PolicyComplianceStatusComponent {
    @Input() category: any;
    protected readonly PolicyCompliance = PolicyCompliance;


}
